﻿/**
 * App configuration
 * Variables for controlling different base values for application
 * @package Project/Configuration
 */

const config = {
    // # Iframe Resizer
    iframeResizerSettings: {
        scrolling: false,
        widthCalculationMethod: 'rightMostElement',
        heightCalculationMethod: 'lowestElement'
    },
    // # Mediaqueries
    mq: {
        xs: '480px',
        sm: '768px',
        md: '992px',
        lg: '1200px'
    }
};

export default config;